import { useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { openImportPicker } from '@/features/import';
import { isTauri } from '@/lib/platform';

import { interpretKey, isTypingTarget } from './shortcuts';
import { useShortcutsDialog } from './shortcuts-dialog-store';

/** How long after G the second key still counts. */
const SEQUENCE_MS = 1200;

/** The page-level shortcuts in `shortcuts.ts`. Mounted once, in the root layout. */
export function useKeyboardShortcuts(): void {
  const navigate = useNavigate();

  useEffect(() => {
    const desktop = isTauri();
    let gAt = 0;
    const onKey = (event: KeyboardEvent) => {
      if (event.defaultPrevented || isTypingTarget(event.target)) {
        return;
      }
      const pendingG = Date.now() - gAt < SEQUENCE_MS;
      const action = interpretKey(event, pendingG, desktop);
      gAt =
        !pendingG && event.key.toLowerCase() === 'g' && !event.metaKey && !event.ctrlKey
          ? Date.now()
          : 0;
      if (action === null) {
        return;
      }
      event.preventDefault();
      switch (action.kind) {
        case 'import':
          openImportPicker();
          break;
        case 'help':
          useShortcutsDialog.setState({ open: true });
          break;
        case 'navigate':
          void navigate({ to: action.to });
          break;
      }
    };
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('keydown', onKey);
    };
  }, [navigate]);
}
